document.addEventListener('DOMContentLoaded', function () {
    AOS.init();
});


//PDP invite code Js

document.addEventListener("DOMContentLoaded", () => {

    const inviteGate = document.querySelector(".invite-gate");
    if (!inviteGate) return;

    const input = inviteGate.querySelector(".invite-gate__input");
    const button = inviteGate.querySelector(".invite-gate__verify");
    const error = inviteGate.querySelector(".invite-gate__error");
    const productForm = document.querySelector(".product-form");
    const productprice = document.querySelector(".price_main");

    const shipRegion = button.dataset.region || "";

    // Check for invite code in URL
    const urlParams = new URLSearchParams(window.location.search);
    const inviteCode = urlParams.get("invite");

    if (inviteCode) {
        input.value = inviteCode;
    }

    function showError(message) {
        error.textContent = message;
        input.classList.add("error");
    }

    function clearError() {
        error.textContent = "";
        input.classList.remove("error");
    }

    input.addEventListener("focus", clearError);

    button.addEventListener("click", async () => {
        clearError();

        const code = input.value.trim();
        if (!code) {
            showError("That code isn't valid. Check it and try again.");
            return;
        }

        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = "Verifying...";

        try {
            const response = await fetch(
                // "https://dddemo.net/php/2026/shreya/webshop_api/validate.php",
                "https://vibe-science-ruddy.vercel.app/api/validate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        code: code,
                        shipRegion: shipRegion
                    })
                }
            );

            // Optional 2 second delay
            await new Promise(resolve => setTimeout(resolve, 2000));
            const result = await response.json();
            // console.log(result); 
              if (
                  result.success &&
                  result.data &&
                  result.data.valid === true
              ) {

                  // Save cart attributes
                  await fetch("/cart/update.js", {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json"
                      },
                      body: JSON.stringify({
                          attributes: {
                              validate_code: code,
                              shipregion: shipRegion
                          }
                      })
                  });

                  inviteGate.style.display = "none";

                  if (productForm) {
                      productForm.classList.remove("hidden");
                  }
                  if(productprice){
                    productprice.classList.remove('hidden');
                  }

              } else {

                  let message = "Invalid invite code.";
                  if (result.data) {
                        if (result.data.reason == 'expired') {
                        message = "This code has expired. Please try another code.";
                        } else if (result.data.reason == 'used_up') {
                        message = "This code has already reached its redemption limit. Please try another code.";
                        }
                    //   if (result.data.reason) {
                    //       message = result.data.reason;
                    //   } else if (!result.data.regionOk) {
                    //       message = "This invite code is not valid for your region.";
                    //   } else if (result.data.status !== "active") {
                    //       message = "This invite code is inactive.";
                    //   } else if (result.data.redemptionsLeft === 0) {
                    //       message = "This invite code has reached its redemption limit.";
                    //   } 
                  }
                  showError(message);
              }

        } catch (e) {
            console.error(e);
            showError("Something went wrong. Please try again.");
        } finally {
            button.disabled = false;
            button.textContent = originalText;
        }
    });
});
//PDP invite code Js end



let allowCheckout = false;

document.addEventListener("click", async function (e) {
    const checkoutBtn = e.target.closest('[name="checkout"]');
    if (!checkoutBtn) return;

    // Already validated, allow Shopify's normal checkout behavior
    if (allowCheckout) {
        allowCheckout = false;
        return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    try {
        // Get cart
        const cart = await fetch("/cart.js").then(r => r.json());

        const code = cart.attributes.validate_code;
        const shipRegion = cart.attributes.shipregion;

        if (!code || !shipRegion) {
            await fetch("/cart/clear.js", { method: "POST" });
            window.location.href = "/products/the-mask";
            return;
        }

        // Validate invite code
        const result = await fetch(
            // "https://dddemo.net/php/2026/shreya/webshop_api/validate.php",
            "https://vibe-science-ruddy.vercel.app/api/validate",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code,
                    shipRegion
                })
            }
        ).then(r => r.json());

        if (
            result.success &&
            result.data &&
            result.data.valid === true
        ) {
            // Allow the next click to proceed normally
            allowCheckout = true;

            // Trigger the original button behavior
            checkoutBtn.click();

        } else {

            await fetch("/cart/clear.js", { method: "POST" });

            alert("Your invite code is no longer valid.");

            window.location.href =
                "/products/the-mask?invite=" +
                encodeURIComponent(code);
        }

    } catch (err) {
        console.error(err);
        alert("Unable to validate invite code.");
    }

}, true);